import { makeStyles } from '@material-ui/core/styles';

/**
 * Estilos para la lista de Artifacts del módulo IA
 */
export const artifactListStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        height: '100%',
    },
    listContainer: {
        flex: 1,
        overflow: 'auto',
        padding: theme.spacing(3),
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3),
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: theme.spacing(2),
    },
    card: {
        padding: theme.spacing(2.5),
        borderRadius: 12,
        border: '1px solid #f3f4f6',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            borderColor: 'rgba(139, 92, 246, 0.3)',
            boxShadow: '0 4px 12px rgba(139, 92, 246, 0.08)',
        },
    },
    cardTitle: {
        fontWeight: 600,
        fontSize: '0.95rem',
        color: '#1e1b4b',
        marginBottom: 4,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    cardMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    badge: {
        fontSize: '0.65rem',
        fontWeight: 600,
        height: 20,
        borderRadius: 10,
    },
    badgeDraft: {
        backgroundColor: '#fef3c7',
        color: '#92400e',
    },
    badgeApproved: {
        backgroundColor: '#dcfce7',
        color: '#15803d',
    },
    badgePending: {
        backgroundColor: '#dbeafe',
        color: '#1e40af',
    },
    badgeChangesRequested: {
        backgroundColor: '#ffedd5',
        color: '#b45309',
    },
    badgeRejected: {
        backgroundColor: '#fee2e2',
        color: '#b91c1c',
    },
    version: {
        fontSize: '0.75rem',
        color: '#6b7280',
    },
    date: {
        fontSize: '0.75rem',
        color: '#9ca3af',
    },
    empty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        color: '#6b7280',
        gap: theme.spacing(1),
    },
    loading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
}));
